// Presentation only. Shopify's existing native localization form remains authoritative.
(() => {
 const root=document.querySelector('dime-market'),choice=root?.querySelector('details'),trigger=choice?.querySelector('summary');
 if(!choice||!trigger)return;
 choice.addEventListener('toggle',()=>trigger.setAttribute('aria-expanded',String(choice.open)));
 choice.addEventListener('keydown',event=>{if(event.key==='Escape'&&choice.open){choice.open=false;trigger.focus();event.stopPropagation()}});
 document.addEventListener('click',event=>{if(choice.open&&event.target instanceof Node&&!root.contains(event.target))choice.open=false});
})();
